import { $api } from "../AxiosInstance";

export class OrderService {
  static async getOrders(params) {
    return await $api.post("/api/admin/order", { ...params, page: params.page - 1 });
  }

  static async getOrderById(id) {
    return await $api.get("/api/admin/orderById", { params: { id } });
  }

  static async saveOrder(orderId, projectId, payed) {
    return await $api.post("/api/admin/changeProject", {
      orderId,
      projectId,
      payed,
    });
  }

  static async confirmOrderPaymentById(id) {
    return await $api.get("/api/admin/payment/confirmedById", { params: { id } });
  }

  static async getReplenishments(params) {
    return await $api.post("/api/admin/payment/getReplenishmentBalance", {
      ...params,
      page: params.page - 1,
    });
  }

  static async confirmedReplenishmentsById(id) {
    return await $api.get("/api/admin/payment/confirmedById", {
      params: { id },
    });
  }

  static async getOrdersExtend(params) {
    return await $api.post("/api/admin/queryOrderExtend", {
      ...params,
      page: params.page - 1,
    });
  }

  static async getExtendProxies(orderId) {
    return await $api.get("/api/admin/extendOrder/byOrder", { params: { orderId } });
  }

  static async getExtendProxyById(id) {
    return await $api.get("/api/admin/extendOrder/byId", { params: { id } });
  }

  static async updateIpIds(id) {
    return await $api.get(" /api/admin/extendOrder/updateIpIds", { params: { id } });
  }

  static async confirmPaymentExtendProxies(id) {
    return await $api.post("/api/admin/extendOrder/paymentConfirmed", null, {
      params: { id },
    });
  }
}
